import { useDispatch, useSelector } from 'react-redux';
import { areaProfilingActions } from '../../store/area-profiling/area-profiling.slice';
import {
  doDownloadCatchmentResult,
  doDownloadVillageResult,
  downloadSummary,
  getAhsMArkers,
  getResultAreaProfiling,
} from '../../store/area-profiling/area-profilisng.asyncAction';

export const useAreaProfiling = () => {
  const state = useSelector(
    /**
     * @param {ReturnType<typeof import('../../../../../redux/rootStore.js').rootStore.getState>} state
     */
    (state) => state.features.DANONE.areaProfiling
  );
  const dispatch = useDispatch();

  const resetState = () => dispatch(areaProfilingActions.resetState());
  const setShowPOI = (value) => dispatch(areaProfilingActions.showPOI(value));
  const setShowPolygon = (value) =>
    dispatch(areaProfilingActions.showPolygon(value));
  const setStep = (value) => dispatch(areaProfilingActions.setStep(value));
  const resetStatus = (param) =>
    dispatch(areaProfilingActions.resetStatus(param));
  /**
   * @param {'AREA' | 'MARKER'} value
   */
  const setTabActive = (value) =>
    dispatch(areaProfilingActions.setTabActive(value));

  /**
   *
   * @param {object} param
   * @param {string} param.provinsi
   * @param {string} param.kodepodes
   * @param {string} param.customer_id
   * @param {number} param.latitude
   * @param {number} param.longitude
   * @returns
   */
  const getAreaProfilingResult = (param) =>
    dispatch(getResultAreaProfiling(param));

  const getMarkers = (param) => dispatch(getAhsMArkers(param));

  const doDownloadSummary = (param) => dispatch(downloadSummary(param));

  const downloadVillageResult = (param) =>
    dispatch(doDownloadVillageResult(param));

  const downloadCatchmentResult = (param) =>
    dispatch(doDownloadCatchmentResult(param));
  return {
    state,
    resetState,
    setShowPOI,
    setShowPolygon,
    setStep,
    setTabActive,
    resetStatus,
    getAreaProfilingResult,
    getMarkers,
    doDownloadSummary,
    downloadVillageResult,
    downloadCatchmentResult,
  };
};
